import { Box, styled } from "@mui/material";
import { IAddNotePayload, INote, INotePayload, NoteClickSignature, NoteDrawerMode } from "models/notes";
import NoteContent from "./NoteContent";
import NoteHeading from "./NoteHeading";
import NoteEdit from "./NoteEdit";

const NoteCardContainer = styled(Box)((props) => ({
    display: "flex",
    borderTop: `1px solid ${props.theme.palette.divider}`,
    paddingBottom: '1em',
    paddingTop: '1em',
    paddingLeft: '60px',
    flexDirection: 'column'
}));

type NoteCardProps = {
    note: INote;
    allowReply?: boolean;
    onReplyClick: NoteClickSignature;
    onEditClick: NoteClickSignature;
    onDeleteClick: NoteClickSignature;
    mode: NoteDrawerMode;
    open: boolean;
    sourceNote?: INote | null;
    draft?: boolean;
    onClose: () => void;
    onSave: (mode: NoteDrawerMode, payload: INotePayload | IAddNotePayload, noteId?: number) => void;
};

const NoteCard: React.FC<NoteCardProps> = (props: NoteCardProps) => {
    const { 
        note, 
        allowReply,
        onReplyClick,
        onEditClick,
        onDeleteClick,
        mode,
        open,
        sourceNote,
        draft,
        onClose,
        onSave,
    } = props;

    return (<>        
        <NoteCardContainer>
            <NoteHeading note={note} avatar/>
            {
                open && mode === 'edit' && sourceNote && sourceNote.id === note.id &&
                <NoteEdit 
                    mode={mode}
                    sourceNote={sourceNote}
                    onClose={onClose}
                    onSave={onSave}
                    draft={draft}
                />
                ||
                <>
                <NoteContent note={note} allowReply={allowReply} 
                    onReplyClick={onReplyClick}
                    onEditClick={onEditClick}
                    onDeleteClick={onDeleteClick}
                    mode={mode}
                    open={open}
                    sourceNote={sourceNote}
                    onClose={onClose}
                    onSave={onSave}
                    draft={draft}
                />
                {open && mode === 'reply' && sourceNote && sourceNote.id === note.id &&
                    <NoteEdit 
                        mode={mode}
                        sourceNote={sourceNote}
                        onClose={onClose}
                        onSave={onSave}
                        draft={draft}
                    />
                }
                </>
            }
        </NoteCardContainer>
    </>);
};

export default NoteCard;